// extracted by mini-css-extract-plugin
export default {"active":"orders-module__active--CLH5Z","activeTitle":"orders-module__activeTitle--Ix8jP"};